import { Events } from './Events.js';
import { Dispatcher } from './Dispatcher.js';

const Actions = {
    emitPage(name) {
        Dispatcher.emit(Events.EMIT_PAGE, name);
    },
    hideFooter() {
        Dispatcher.emit(Events.HIDE_FOOTER);
    },
    showFooter() {
        Dispatcher.emit(Events.SHOW_FOOTER);
    },
    openService() {
        Dispatcher.emit(Events.OPEN_SERVICE);
    },
    closeService() {
        Dispatcher.emit(Events.CLOSE_SERVICE);
    },
    menuIntern() {
        Dispatcher.emit(Events.MENU_INTERN);
    },
    menuHome() {
        Dispatcher.emit(Events.MENU_HOME);
    },
    logoHome() {
        Dispatcher.emit(Events.LOGO_HOME);
    },
    logoIntern() {
        Dispatcher.emit(Events.LOGO_INTERN);
    },
    hideScrollIntern(end) {
        if (end) {
            Dispatcher.emit(Events.HIDE_SCROLL_INTERN);
        } else {
            Dispatcher.emit(Events.SHOW_SCROLL_INTERN);
        }
    },
    successForm() {
        Dispatcher.emit(Events.SUCCESS_FORM);
    },
    globalTransition() {
        Dispatcher.emit(Events.GLOBAL_TRANSITION);
    },
    closeServiceRequest() {
        Dispatcher.emit(Events.CLOSE_SERVICE_REQUEST);
    }
};

export { Actions };
